import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { Button } from '@/common/ui/button'
import { Link } from 'react-router-dom'
import EventTable from '../EventTable'
import useQueryProfile from '@/modules/auth/api/hooks/useQueryProfile'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import type { UnifiedEventData } from '@/modules/events/type'

interface EventListingProps {
	data: UnifiedEventData[]
	total: number
	isLoading?: boolean
}

export default function EventListing({
	data,
	total,
	isLoading,
}: EventListingProps) {
	const { data: user } = useQueryProfile()
	const hasWritePermission = user?.userGroup.writePermission.includes(
		PermissionKeys.WEB_SETTING,
	)

	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading title="จัดการกิจกรรม" description="รายการกิจกรรมทั้งหมด" />
				{hasWritePermission && (
					<Button asChild variant="default">
						<Link to="/operator/events/create-event?type=TURNOVER">
							สร้างกิจกรรมเทิร์นโอเวอร์
						</Link>
					</Button>
				)}
			</div>
			<Separator />
			<EventTable data={data} total={total} isLoading={isLoading} />
		</div>
	)
}
